import React, { useState } from "react";
import { toast } from "react-toastify";
import { Typography } from "@mui/material";
import { GetUserId } from "../../../Utils/Utils";
import StarRating from "./StarRating";
import { submitFeedback } from "./feedbackApi";
import "../AtlasChatComponent.css";

const GoodFeedbackForm = ({ open, onClose, sessionId }) => {
  const feedbackOptions = [
    "Data was accurate and verified",
    "Relevant sites/needs were found",
    "Report was comprehensive and well-structured",
    "Answered my question completely",
    "Fast and responsive",
  ];
  const [submitting, setSubmitting] = useState(false);
  const [contactDetails, setContactDetails] = useState({
    userExperience: "",
    userExperienceAccuracy: "",
    userExperienceUnderstandability: "",
    overallExperience: "",
  });
  const [selectedOptions, setSelectedOptions] = useState([]);
  const handleSelect = (option) => {
    setSelectedOptions((prev) => (prev.includes(option) ? [] : [option]));
  };

  const validate = () => {
    if (selectedOptions.length === 0) {
      toast.error("Please select at least one option");
      return false;
    }
    if (!contactDetails.userExperienceAccuracy.trim()) {
      toast.error("Please Enter User Experience Accuracy");
      return false;
    }
    if (!contactDetails.userExperienceUnderstandability.trim()) {
      toast.error("Please Enter User Experience Understandability");
      return false;
    }
    if (!contactDetails.overallExperience.trim()) {
      toast.error("Please Enter Overall Experience");
      return false;
    }
    return true;
  };
  const handleSubmit = async () => {
    if (!validate()) return;
    setSubmitting(true);
    const userId = GetUserId();
    const payload = {
      user_id: Number(userId),
      session_id: sessionId || "",
      feedback: selectedOptions[0],
      // feedback: contactDetails.userExperience,
      accuracy_score: Number(contactDetails.userExperienceAccuracy),
      understandability_score: Number(
        contactDetails.userExperienceUnderstandability,
      ),
      overall_score: Number(contactDetails.overallExperience),
      created_at: new Date(),
    };

    try {
      await submitFeedback(payload);
      toast.success("Thanks for the feedback!");
      setSelectedOptions([]);
      setContactDetails({
        userExperience: "",
        selectedOptions: [],
        userExperienceAccuracy: "",
        userExperienceUnderstandability: "",
        overallExperience: "",
      });
      onClose();
    } catch {
      toast.error("Something went wrong, please try again!");
    } finally {
      setSubmitting(false);
    }
  };

  if (!open) return null;

  return (
    <div
      className="fbp-overlay"
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: "20px",
      }}
    >
      <div className="fbp-card" onClick={(e) => e.stopPropagation()}>
        <div className="fbp-header-good">
          <h3>👍 What was good?</h3>
          <button className="fbp-close" onClick={onClose} aria-label="Close">
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="fbp-body">
          <div className="fbp-row">
            <div className="good-feedback-opts">
              {feedbackOptions.map((option, index) => (
                <div
                  key={index}
                  className={`good-feedback-chip ${
                    selectedOptions.includes(option) ? "active" : ""
                  }`}
                  onClick={() => handleSelect(option)}
                >
                  {option}
                </div>
              ))}
            </div>

            <div className="fbp-row-cols">
              <StarRating
                label="Accuracy"
                required
                value={Number(contactDetails.userExperienceAccuracy) || 0}
                onChange={(v) =>
                  setContactDetails((prev) => ({
                    ...prev,
                    userExperienceAccuracy: String(v),
                  }))
                }
              />
              <StarRating
                label="Understandability"
                required
                value={
                  Number(contactDetails.userExperienceUnderstandability) || 0
                }
                onChange={(v) =>
                  setContactDetails((prev) => ({
                    ...prev,
                    userExperienceUnderstandability: String(v),
                  }))
                }
              />
              <StarRating
                label="Overall"
                required
                value={Number(contactDetails.overallExperience) || 0}
                onChange={(v) =>
                  setContactDetails((prev) => ({
                    ...prev,
                    overallExperience: String(v),
                  }))
                }
              />
            </div>

            <div>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 500,
                  color: "#333",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                Feedback <span className="good-baad-word-limit">Optional</span>
              </Typography>
              <textarea
                className="input-floating-label cff-height"
                required
                onChange={(e) =>
                  setContactDetails((prev) => ({
                    ...prev,
                    userExperience: e.target.value,
                  }))
                }
                value={contactDetails.userExperience}
                placeholder="Max 500 words"
                rows={5}
                maxLength={500}
              />
            </div>
            <p className="good-baad-word-limit">0/500 words</p>
          </div>

          <div className="fbp-actions">
            <button
              type="button"
              className="fbp-btn ghost"
              onClick={onClose}
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              // className={
              //   selectedOptions.length > 0 ? "fbp-btn primary" : "fbp-btn-grey"
              // }
              className="fbp-btn primary"
              disabled={submitting}
              onClick={handleSubmit}
            >
              {submitting ? "Submitting..." : "Submit Feedback"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoodFeedbackForm;
